import { render } from "./CartAmountButton.vue?vue&type=template&id=ca50a6a8"
import script from "./CartAmountButton.vue?vue&type=script&lang=js"
export * from "./CartAmountButton.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/app/components/CartAmountButton.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "ca50a6a8"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('ca50a6a8', __exports__)) {
    api.reload('ca50a6a8', __exports__)
  }
  
  module.hot.accept("./CartAmountButton.vue?vue&type=template&id=ca50a6a8", () => {
    api.rerender('ca50a6a8', render)
  })

}


export default __exports__